module.exports = __webpack_public_path__ + "static/media/Fourth-FlagLarge.d5f397bb.png";